import "./index.scss";
import CareerSection from "./CareerSection/CareerSection";
import PersonalSection from "./PersonalSection/PersonalSection";
import { useState } from "react";
import my_image from "./assets/my_image.jpg";
import linkedinLogo from "./assets/linkedin-logo.png";
import gitHubLogo from "./assets/github-logo.png";

const MyPage = () => {
  const [showCareer] = useState(false);
  const [showInterests] = useState(true);
  // const steamUrl =
  //   "https://steam-current-game.vercel.app/api/?steamids=%3C76561199036317971%3E";

  // const showCareerSection = () => {
  //   setShowCareer(true);
  //   setShowInterests(false);
  // };
  // const showInterestsSection = () => {
  //   setShowInterests(true);
  //   setShowCareer(false);
  // };
  return (
    <>
      <div className="banner">
        <div className="container">
          <div className="button-group">
            {/* <button
              className="button-style"
              type="button"
              onClick={showCareerSection}
            >
              My Career
            </button>
            <button
              className="button-style"
              type="button"
              onClick={showInterestsSection}
            >
              My Interests
            </button> */}
          </div>
          <div className="welcome row">
            <img
              alt="Profile Pic"
              className="welcome-image col-md-3"
              src={my_image}
            />
            <div className="welcome-message-wrapper col-md-9">
              <span className="welcome-message">Sri Vishnu Pasumarthi</span>
              <span className="welcome-message-subtext">Web Developer</span>

              <div className="contact-content">
                <a
                  href="https://www.linkedin.com/in/sri-vishnu-pasumarthi/"
                  className="contact-link"
                >
                  <img
                    src={linkedinLogo}
                    alt="LinkedIn"
                    className="contact-logo"
                  />
                </a>

                <a href="https://github.com/srivishp" className="contact-link">
                  <img src={gitHubLogo} alt="GitHub" className="contact-logo" />
                </a>
              </div>
              <div className="banner-desc">
                <p>
                  Hi, I’m Vishnu 👋 I love watching F1 and reading books in the
                  science & non-fiction genres. I’m always down for
                  conversations about space, technology & engineering. I love
                  geeky humor and I'm a huge fan of the XKCD web comics & the
                  What If? book series. I listen to music 🎵, watch movies 🎬 or
                  play video games 🎮 to relax.
                </p>
                {/* <img
                className="steam-card"
                src={steamUrl}
                title="Steam Current Game"
                alt="Current Steam Status"
              /> */}
              </div>

              {/* <span className="welcome-message-subtext">
              Frontend Developer | Azure & AWS Certified
            </span> */}
            </div>
          </div>
        </div>
      </div>

      {showCareer ? <CareerSection /> : null}
      {showInterests ? <PersonalSection /> : null}
    </>
  );
};

export default MyPage;
